import _ from 'lodash';
import { getSubscription, getBalancePackages, getCrossSaler } from '@/services/';
import BalanceCard from '@/components/supplier/balance-purchase/balance-card';
import RestrictedModal from '@/components/supplier/balance-purchase/modal/restricted-permission';
import Restricted from '@/components/supplier/balance-purchase/modal/restricted';
import { sendContactUsRequest } from '@/services';
import { mapActions } from 'vuex';

export default {
    name: 'BalancePurchase',
    components: {
        BalanceCard,
        RestrictedModal,
        Restricted
    },
    data: () => ({
        isMobile: false,
        balancePackages: [],
        supplierHasActiveSubscription: false,
        canAcquireBalance: false,
        loading: true,
        supplierInfo: {
            name: '',
            email: '',
            reason: 'Interesse em assinatura',
            message: 'Estou interessado em uma nova assinatura',
            phone: ''
        },
        loadingButton: false,
        chosenPackage: [],
        customPackage: [],
        invalidPackage: false
    }),
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    async created() {
        await this.getPackages();
        await this.getSubscription();
    },
    methods: {
        ...mapActions('payment', ['setPackageId']),
        ...mapActions('payment', ['setPlanId']),
        ...mapActions('checkout', ['setPackageCoin']),
        async getCrossSaler() {
            try {
                const results = await getCrossSaler();
                return results
            } catch (error) {
                console.error(error);
            }
        },
        async getPackages() {
            try {
                const { results } = await getBalancePackages();
                this.balancePackages = results.filter(item => item.isCustom === false);
                this.customPackage = results.filter(item => item.isCustom === true);
            } catch (error) {
                console.error(error);
            }
        },
        async getSubscription() {
            try {
                const { data, error } = await getSubscription();
                if (!error) {
                    const subscription = data;
                    const supplierHasSubscription = !_.isEmpty(subscription);
                    this.supplierHasActiveSubscription = supplierHasSubscription && subscription.isActive;
                    this.canAcquireBalance = subscription.canAcquireEngelinkCash;
                    this.loading = false;
                } else {
                    this.loading = false;
                    await this.getCrossSaler();
                }
            } catch (e) {
                await this.getCrossSaler();
            }
        },
        ...mapActions('notification', ['showNotification']),
        ...mapActions('sweetalert2', ['showAlert']),
        async requestInfoSignature() {
            try {
                this.loadingButton = true;
                const request = await sendContactUsRequest(this.supplierInfo);
                if (request) {
                    this.$swal({
                        title: 'Sua solicitação foi enviada!',
                        text: 'Um dos nossos epecialistas entrará em contato com você',
                        icon: 'success',
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        showCloseButton: true
                    }).then(() => {
                        this.$router.push({ name: 'CompetitionDashboard' });
                    });
                }
            } catch (error) {
                this.loadingButton = false;
                console.error(error);
                this.showNotification({ text: 'Aconteceu um erro inesperado', type: 'error' });
            } finally {
                this.loadingButton = false;
            }
        },
        setPackageBalance(chosen) {
            this.chosenPackage = chosen;
        },
        async selectPackages() {
            let data = {};
            if (this.chosenPackage.isCustom === true) {
                data = {
                    id: this.chosenPackage.id,
                    // eslint-disable-next-line no-useless-escape
                    transactionValue: this.chosenPackage.transactionValue.replace(/\./g, '').replace(/\,/g, '.'),
                    description: this.chosenPackage.description,
                    name: this.chosenPackage.name,
                    type: 'coin',
                    isCustom: true
                };
            } else {
                data = {
                    id: this.chosenPackage.id,
                    transactionValue: this.chosenPackage.transactionValue,
                    description: this.chosenPackage.description,
                    name: this.chosenPackage.name,
                    type: 'coin',
                    isCustom: false
                };
            }
            try {
                this.loadingButton = true;
                await this.setPackageCoin(data);
                await this.$router.push({ name: 'New Checkout' });
            } catch (error) {
                this.loadingButton = false;
                console.error(error);
                this.showNotification({ text: 'Aconteceu um erro inesperado', type: 'error' });
            } finally {
                this.loadingButton = false;
            }
        }
    },
    computed: {
        buttonSize() {
            return this.isMobile ? true : false;
        }
    }
};
